export const AUTHORIZATION_KEY = "AUTHORIZATION_KEY";
export const REFRESH_TOKEN_KEY = "REFRESH_TOKEN_KEY";
